import * as media from './media';
import * as role from './role';
import * as user from './user';

export default {
  media,
  role,
  user,
};
